// ============================================================================
// CHANGO V5.0 — 报价单国际化标签字典
// ============================================================================
// 支持三种渲染模式：中文、英文、中英对照
// Task #113: 报价单双语支持
// ============================================================================

export const LABELS_ZH = {
  quotation: '报价单',
  status: '状态',
  issued_at: '出具于',
  responsible: '负责人',
  buyer: '买方',
  terms: '报价条款',
  currency_label: '币种',
  exchange_rate: '汇率',
  discount: '折扣',
  tax_rate: '税率',
  line_items: '商品明细',
  number: '#',
  sku: 'SKU',
  description: '描述',
  quantity: '数量',
  unit_price: '单价',
  subtotal: '小计',
  line_subtotal: '行小计',
  sales_subtotal: '销售小计',
  discount_amount: '折扣金额',
  sales_after_discount: '折扣后销售',
  tax: '税额',
  total_due: '应付合计',
  exchange: '折算',
  internal_info: '内部信息（请在打印前确认是否需要保留）',
  cost: '成本',
  gross_profit: '毛利',
  margin_rate: '毛利率',
  footer_note: '本报价经双人复核（§20 #4）。自出具日起 30 日内有效；超期请联系负责人重新报价。',
  export_time: '导出时间',
  legend: '编号'
};

export const LABELS_EN = {
  quotation: 'Quotation',
  status: 'Status',
  issued_at: 'Issued on',
  responsible: 'Owner',
  buyer: 'Customer',
  terms: 'Terms',
  currency_label: 'Currency',
  exchange_rate: 'Exchange Rate',
  discount: 'Discount',
  tax_rate: 'Tax Rate',
  line_items: 'Line Items',
  number: '#',
  sku: 'SKU',
  description: 'Description',
  quantity: 'Qty',
  unit_price: 'Unit Price',
  subtotal: 'Subtotal',
  line_subtotal: 'Line Total',
  sales_subtotal: 'Subtotal',
  discount_amount: 'Discount',
  sales_after_discount: 'After Discount',
  tax: 'Tax',
  total_due: 'Total Due',
  exchange: 'Converted',
  internal_info: 'Internal Information (Please confirm before printing)',
  cost: 'Cost',
  gross_profit: 'Gross Profit',
  margin_rate: 'Margin %',
  footer_note: 'This quotation has been reviewed by two persons (§20 #4). Valid for 30 days from issue date; please contact the owner for renewal.',
  export_time: 'Export Time',
  legend: 'No.'
};

export const LABELS_BI = {
  quotation: '报价单 / Quotation',
  status: '状态 / Status',
  issued_at: '出具于 / Issued on',
  responsible: '负责人 / Owner',
  buyer: '买方 / Customer',
  terms: '报价条款 / Terms',
  currency_label: '币种 / Currency',
  exchange_rate: '汇率 / Exchange Rate',
  discount: '折扣 / Discount',
  tax_rate: '税率 / Tax Rate',
  line_items: '商品明细 / Line Items',
  number: '#',
  sku: 'SKU',
  description: '描述 / Description',
  quantity: '数量 / Qty',
  unit_price: '单价 / Unit Price',
  subtotal: '小计 / Subtotal',
  line_subtotal: '行小计 / Line Total',
  sales_subtotal: '销售小计 / Subtotal',
  discount_amount: '折扣金额 / Discount',
  sales_after_discount: '折扣后销售 / After Discount',
  tax: '税额 / Tax',
  total_due: '应付合计 / Total Due',
  exchange: '折算 / Converted',
  internal_info: '内部信息 / Internal Information（请在打印前确认是否需要保留 / Please confirm before printing）',
  cost: '成本 / Cost',
  gross_profit: '毛利 / Gross Profit',
  margin_rate: '毛利率 / Margin %',
  footer_note: '本报价经双人复核（§20 #4）/ This quotation has been reviewed by two persons (§20 #4)。自出具日起 30 日内有效 / Valid for 30 days from issue date；超期请联系负责人重新报价 / please contact the owner for renewal。',
  export_time: '导出时间 / Export Time',
  legend: '编号 / No.'
};

/**
 * 按语言模式返回对应的标签字典
 * @param {string} lang - 'zh' | 'en' | 'bilingual'
 * @returns {object}
 */
export function getLabelsByLang(lang) {
  switch (lang) {
    case 'en':
      return LABELS_EN;
    case 'bilingual':
      return LABELS_BI;
    case 'zh':
    default:
      return LABELS_ZH;
  }
}
